import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardSocialCommon } from '../../../shared';

export const FeedCardAdminSocial: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  return <FeedCardSocialCommon card={card} />;
});
